import formatNumber from './format-number';

export default (value: number): string => {
  if (value >= 1000000) {
    // 1500000 -> 1.5m ton
    const formattedVal = formatNumber(value / 1000000, 2);
    return `${formattedVal}m ton`;
  }
  if (value >= 1000) {
    // 8000 -> 8k ton
    const formattedVal: String = formatNumber(Math.round(value / 1000));
    return `${formattedVal}k ton`;
  }
  const formattedVal: String = formatNumber(Math.round(value));
  return `${formattedVal} ton`;
};
